import styled from "styled-components";

export const DateRangePickerContainer = styled.div`
	border: 1px solid rgba(0, 0, 0, 0.2);
	padding: 3px;
	border-radius: 5px;

	&:hover {
		border: 1px solid #000;
	}
`;
